import React from 'react';
import { Button, IconButton } from '@chakra-ui/react';
import { IoReload } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';

const SearchBar = ({
  list,
  placeholder,
  onChange,
  value,
  onSearch,
  onReloadSearch,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <input
        className="form-control me-3"
        type="text"
        id="searchInput"
        list="words"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      <datalist id="words">
        {list.map((palabra, index) => (
          <option
            key={index}
            value={palabra}
          />
        ))}
      </datalist>

      <Button
        colorScheme={'blue'}
        type="submit"
        onClick={onSearch}
      >
        {t('SEARCH')}
      </Button>

      <IconButton
        alt={t('RESET_SEARCH')}
        onClick={onReloadSearch}
        icon={<IoReload />}
      />
    </>
  );
};

export default SearchBar;
